// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"layers"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M4.5 6.125L12 3L19.5 6.125L12 9.25L4.5 6.125Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4.5 6.125L12 3L19.5 6.125L12 9.25L4.5 6.125Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M3 11.5005L12 15.3771L21 11.5005M21 17.5005L12 21.3771L3 17.5005","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-layers')
export default class LayersIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'layers',
    }
  }
}
